import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { useSubsidiaryVatCodesApi } from "../../http/subsidiaryVatCodes/api";
import HistoryDialog from "../ui/HistoryDialog";
import VersionDialog from "../ui/VersionDialog";

type SubsidiaryVatCodeHistoryDialogProps = {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
};

const SubsidiaryVatCodeHistoryDialog: FC<SubsidiaryVatCodeHistoryDialogProps> = ({
  itemToShowVersionsId,
  itemVersionToShowVersions,
  onClose,
}) => {
  const i18n = useI18n();
  const subsidiaryVatCodeApi = useSubsidiaryVatCodesApi();

  return (
    <HistoryDialog
      title={i18n.t.subsidiaries.versions}
      lastVersion={itemVersionToShowVersions}
      entityId={itemToShowVersionsId}
      getEntityVersionHook={subsidiaryVatCodeApi.getAdminSubsidiaryVatCodeVersion}
      getHistory={subsidiaryVatCodeApi.getAdminSubsidiaryVatCodeHistory}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <>
          <VersionDialog.Table headers={headers}>
            {dataVersion.current?.subsidiary.id != dataVersion.next.subsidiary.id && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.name}
                  value={dataVersion.current?.subsidiary.name}
                  edited={dataVersion.next.subsidiary.name}
                />
              </tr>
            )}

            {dataVersion.current?.carCategory != dataVersion.next.carCategory && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.allowMultiplePlates}
                  value={dataVersion.current?.carCategory}
                  edited={dataVersion.next.carCategory}
                />
              </tr>
            )}

            {dataVersion.current?.productCode != dataVersion.next.productCode && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.countryIsoCode}
                  value={dataVersion.current?.productCode}
                  edited={dataVersion.next.productCode}
                />
              </tr>
            )}

            {dataVersion.current?.vatCode != dataVersion.next.vatCode && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.vatCode}
                  value={dataVersion.current?.vatCode}
                  edited={dataVersion.next.vatCode}
                />
              </tr>
            )}
          </VersionDialog.Table>
        </>
      )}
    />
  );
};

export default SubsidiaryVatCodeHistoryDialog;
